import React from "react";
import styled from "styled-components";

const AboutUs = () => {
  return (
    <PageWrapper>
      <ContentCard>
        <MainContent>
          <SectionTitle>About Us</SectionTitle>

          <Paragraph>
            At <strong>Pragan Tech Solutions</strong>, we specialize in building
            scalable, high-performance digital solutions that empower
            businesses to grow in a rapidly evolving technological landscape.
            From startups to established enterprises, we deliver products that
            are secure, efficient, and future-ready.
          </Paragraph>

          <Paragraph>
            Our expertise spans web applications, mobile solutions, cloud-based
            systems, and custom software development. We combine modern
            technologies with thoughtful design to ensure every solution
            delivers real business value.
          </Paragraph>

          <Paragraph>
            Whether you are launching a new product, modernizing an existing
            platform, or scaling your operations, Pragan Tech Solutions partners
            with you at every stage of your digital journey.
          </Paragraph>

          <SectionTitle>Customer Service & Support</SectionTitle>

          <List>
            <li>
              <strong>Dedicated Support:</strong> Our technical support team is
              available to assist with implementation, maintenance, and
              optimization of your solutions.
            </li>
            <li>
              <strong>Consultation Services:</strong> Get expert guidance on
              architecture, performance optimization, and technology selection.
            </li>
            <li>
              <strong>Ongoing Maintenance:</strong> We ensure your systems remain
              secure, updated, and performant post-launch.
            </li>
            <li>
              <strong>Client-Centric Approach:</strong> We prioritize
              transparency, responsiveness, and long-term partnerships.
            </li>
          </List>

          <SectionTitle>Why Choose Pragan Tech Solutions?</SectionTitle>

          <Paragraph>
            At Pragan Tech Solutions, we go beyond just writing code - we build digital
            foundations that help businesses grow with confidence. Every solution we
            create is designed to be secure, scalable, and aligned with your long-term
            goals, ensuring your technology works for you, not against you.
          </Paragraph>

          <Paragraph>
            We take the time to understand your business, your challenges, and your
            vision. By combining modern technology, thoughtful design, and a deep
            commitment to quality, we deliver products that are not only functional but
            truly impactful.
          </Paragraph>

          <Paragraph>
            Whether you’re a startup building your first platform or a growing company
            ready to scale, Pragan Tech Solutions becomes your trusted technology partner
            - providing clear communication, dependable support, and solutions that
            evolve as your business grows.
          </Paragraph>

        </MainContent>

        <SidePanel>
          <SideTitle>Pragan Tech Solutions</SideTitle>

          <SideText>
            Software Development & Technology Consulting
          </SideText>

          <Divider />

          <SideBlock>
            <strong>Head Office</strong>
            <span>Pragan Tech Solutions</span>
            <span>First floor, Joseph Complex, 1, Xavier's Colony, Tirunelveli-627005</span>
            <span>Tamil Nadu, India</span>
          </SideBlock>
           

          <SideBlock>
            <strong>Contact</strong>
            <span>Email: sales@pragantechsolutions.com</span>
            <span>Phone: +91 8072487998</span>
          </SideBlock>

          <SideBlock>
            <strong>Services</strong>

            {/* Development */}
            <SideCategory>Application Development</SideCategory>
            <span>Web Application Development</span>
            <span>Mobile App Development (Android & iOS)</span>
            <span>Custom Software Development</span>
            <span>SaaS Product Development</span>
            <span>Enterprise Application Development</span>

            {/* Business Systems */}
            <SideCategory>Business Solutions</SideCategory>
            <span>CRM Application Development</span>
            <span>ERP & Business Management Systems</span>
            <span>Workflow Automation Solutions</span>
            <span>Billing & Invoicing Systems</span>
            <span>Inventory & POS Systems</span>

            {/* AI & Data */}
            <SideCategory>AI & Data</SideCategory>
            <span>AI-Powered Applications</span>
            <span>Chatbot & Virtual Assistant Development</span>
            <span>Data Analytics & Business Intelligence</span>
            <span>Machine Learning Solutions</span>

            {/* Cloud & Integration */}
            <SideCategory>Cloud & Integration</SideCategory>
            <span>Cloud Application Development</span>
            <span>Cloud Migration & Optimization</span>
            <span>DevOps & CI/CD Automation</span>
            <span>API Development & Integration</span>

            {/* Security & Performance */}
            <SideCategory>Security & Performance</SideCategory>
            <span>Application Security & Penetration Testing</span>
            <span>Performance Optimization</span>

            {/* Support & Growth */}
            <SideCategory>Support & Growth</SideCategory>
            <span>Technical Consulting</span>
            <span>Product Maintenance & Support</span>
            <span>System Upgrades & Modernization</span>
          </SideBlock>

        </SidePanel>
      </ContentCard>
    </PageWrapper>
  );
};

export default AboutUs;
export const PageWrapper = styled.div`
  min-height: 100vh;
  // background: linear-gradient(135deg, #f0f4ff, #f9f9f9);
  padding: 150px 20px 80px 20px;   display: flex;
  justify-content: center;
`;

export const ContentCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 28px;
  max-width: 1200px;
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.12);
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const SideCategory = styled.div`
  margin-top: 18px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #111;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  opacity: 0.75;
`;

export const MainContent = styled.div`
  padding: 64px 56px;

  @media (max-width: 900px) {
    padding: 40px 28px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 18px;
  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 900px) {
    font-size: 28px;
  }
`;



const Paragraph = styled.p`
  font-size: 16.5px;
  line-height: 1.85;
  color: #333;
  margin-bottom: 22px;
`;


const List = styled.ul`
  margin-left: 0;
  padding-left: 0;
  margin-bottom: 36px;

  li {
    list-style: none;
    padding-left: 28px;
    position: relative;
    margin-bottom: 14px;
    line-height: 1.7;
    color: #333;

    &::before {
      content: "✔";
      position: absolute;
      left: 0;
      color: #ff8a3d;
      font-weight: bold;
    }
  }
`;


const SidePanel = styled.div`
  background: linear-gradient(180deg, #fafafa, #f1f1f1);
  padding: 48px 40px;
  border-left: 1px solid rgba(0, 0, 0, 0.05);

  @media (max-width: 900px) {
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
  }
`;

const SideTitle = styled.h3`
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 6px;
  color: #1a1a1a;
`;


const SideText = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 28px;
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  background: linear-gradient(to right, #ddd, transparent);
  margin-bottom: 28px;
`;


const SideBlock = styled.div`
  margin-bottom: 28px;

  strong {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #111;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  span {
    display: block;
    font-size: 14px;
    color: #444;
    line-height: 1.7;
  }
`;

